import { render, staticRenderFns } from "./PitchDeckSection.vue?vue&type=template&id=13b2360f&scoped=true"
import script from "./PitchDeckSection.vue?vue&type=script&lang=js"
export * from "./PitchDeckSection.vue?vue&type=script&lang=js"
import style0 from "./PitchDeckSection.vue?vue&type=style&index=0&id=13b2360f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2360f",
  null
  
)

export default component.exports